import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { http, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await http.post("/auth/login", { email, password });
      if (data?.access_token) localStorage.setItem("admin_token", data.access_token);
      toast.success("Welcome back, Admin.");
      navigate("/admin");
    } catch (err) {
      toast.error(
        formatApiErrorDetail(err.response?.data?.detail) || "Login failed"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center px-6">
      <div
        className="w-full max-w-md border border-white/10 rounded-xl p-8 md:p-10 bg-[#0f0f0f]"
        data-testid="admin-login-card"
      >
        <div className="w-10 h-10 rounded-lg bg-[#FFD700]/10 border border-[#FFD700]/30 flex items-center justify-center">
          <Lock className="h-5 w-5 text-[#FFD700]" />
        </div>
        <h1 className="mt-5 font-display text-3xl tracking-tight">Admin Access</h1>
        <p className="mt-1 text-sm text-gray-400">
          Sign in to view mentorship applications.
        </p>

        <form onSubmit={submit} className="mt-7 space-y-5">
          <div>
            <Label className="text-xs uppercase tracking-wider text-gray-400">Email</Label>
            <Input
              type="email"
              required
              data-testid="admin-login-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 bg-[#1a1a1a] border-white/10 text-white focus-visible:ring-[#FFD700]"
              placeholder="admin@surajmaths.com"
            />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider text-gray-400">Password</Label>
            <Input
              type="password"
              required
              data-testid="admin-login-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 bg-[#1a1a1a] border-white/10 text-white focus-visible:ring-[#FFD700]"
              placeholder="••••••••"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full bg-[#FFD700] hover:bg-[#E6C200] text-black font-semibold uppercase tracking-wide h-11"
          >
            {loading ? (
              <span className="inline-flex items-center gap-2">
                <Loader2 className="h-4 w-4 animate-spin" /> Signing in
              </span>
            ) : (
              "Sign In"
            )}
          </Button>
        </form>

        <a
          href="/"
          className="block text-center text-xs uppercase tracking-[0.22em] text-gray-500 hover:text-white mt-6"
        >
          ← Back to site
        </a>
      </div>
    </div>
  );
}
